import React from 'react';

export default function BrandLogo({ brand, variant = 'header' }) {
  if (variant === 'footer') {
    return (
      <span className="brand-logo brand-logo-footer">
        <img
          className="brand-logo-lockup"
          src="/brand/bharatshiksha-logo-on-dark.png"
          alt={brand}
          width="720"
          height="599"
        />
      </span>
    );
  }

  return (
    <span className="brand-logo">
      <img
        className="brand-logo-mark"
        src="/brand/bharatshiksha-mark.png"
        alt=""
        width="256"
        height="256"
      />
      <img
        className="brand-logo-wordmark-img"
        src="/brand/bharatshiksha-wordmark.png"
        alt={brand}
        width="640"
        height="75"
      />
    </span>
  );
}
